/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultAssistanceInProgress } from '../../models/api-response-paged-result-assistance-in-progress';
import { PagedRequestAssistanceInProgress } from '../../models/paged-request-assistance-in-progress';

export interface SearchAssistanceProgress$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestAssistanceInProgress
}

export function searchAssistanceProgress(http: HttpClient, rootUrl: string, params: SearchAssistanceProgress$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultAssistanceInProgress>> {
  const rb = new RequestBuilder(rootUrl, searchAssistanceProgress.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultAssistanceInProgress>;
    })
  );
}

searchAssistanceProgress.PATH = '/api/ai-assistant/search';
